import React from "react";
import * as FiIcons from "react-icons/fi";
import SafeIcon from "../../../common/SafeIcon";

const { FiMail, FiPhone, FiUser } = FiIcons;

function initials(name) {
  return String(name || "Assigned team member")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join("");
}

export default function ClientAssignedAccountantCard({
  accountant,
}) {
  if (!accountant) return null;

  return (
    <article className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <div className="flex items-start gap-4">
        {accountant.avatarUrl ? (
          <img
            src={accountant.avatarUrl}
            alt=""
            className="h-12 w-12 rounded-xl object-cover"
          />
        ) : (
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-sm font-bold text-emerald-800">
            {initials(accountant.name) || <SafeIcon icon={FiUser} />}
          </span>
        )}
        <div className="min-w-0 flex-1">
          <p className="text-xs font-semibold uppercase tracking-wider text-emerald-700">
            Your Assigned Accountant
          </p>
          <h3 className="mt-1 break-words text-base font-bold text-slate-900">
            {accountant.name}
          </h3>
          <p className="mt-1 text-sm capitalize text-slate-500">
            {accountant.role
              ? accountant.role.replaceAll("_", " ")
              : "Accounting team"}
          </p>
        </div>
      </div>

      <div className="mt-5 flex flex-wrap gap-3">
        {accountant.email && (
          <a
            href={`mailto:${accountant.email}`}
            className="inline-flex items-center gap-2 rounded-lg bg-violet-50 px-3 py-2 text-sm font-semibold text-violet-700 hover:bg-violet-100"
          >
            <SafeIcon icon={FiMail} />
            Email
          </a>
        )}
        {accountant.phone && (
          <a
            href={`tel:${accountant.phone}`}
            className="inline-flex items-center gap-2 rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
          >
            <SafeIcon icon={FiPhone} />
            Call
          </a>
        )}
        {!accountant.email && !accountant.phone && (
          <p className="text-sm text-slate-500">
            Contact information is not available yet.
          </p>
        )}
      </div>
    </article>
  );
}